import { Button, Spinner, Switch } from 'avo-ui'
import { General } from 'components/main-page/home-page/daily-deals/general/General'
import { BannerDailyDealsContainer } from '../../../../containers/main-page/home-page/daily-deals/banner-daily-deals/BannerDailyDealsContainer'

export const DailyDeals = ({ isShow, sectionProps, isLoadingUpload, isLoading, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-6 mb-20'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>Daily Deals</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{!isShow ? 'Hide' : 'Show'}</p>
                            <Switch name={'is_show'} checked={!!isShow} onChange={sectionProps?.onChangeForm} />
                        </div>
                    </div>
                    <div className={'flex flex-col space-y-6'}>
                        <General {...sectionProps} />
                        <BannerDailyDealsContainer {...sectionProps} />
                    </div>
                    <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                        <Button
                            className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                            loading={isLoadingUpload || isUpdating}
                            title={'SAVE ALL CHANGES'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
